import PickUpInformation from "./PickUpInformation";

export default PickUpInformation;
